import { ApiKey as GQLItem } from '../../generated/api.graphql';
import { take } from '../../util';
import { Account } from '../App/Account';
import * as PermissionScope from './PermissionScope';

export type ApiKey = {
  id: number;
  name: string;
  key: string;
  createdAt: string;
  expiresAt: string | null;
  /** Null when the viewer cannot read webhooks; only the key listing selects it. */
  webhookSubscriptionCount?: number | null;
  /** Both are absent on a key issued before the scope work, so neither is guaranteed. */
  account?: Account.Account;
  permissionSet?: PermissionScope.PermissionScope;
};

export type ApiKeyFull = ApiKey & {
  keyUnmasked: string;
};

export const fromGQL = <T = ApiKey | ApiKeyFull>(item: GQLItem): T => ({
  ...take<T>(item, 'id', 'name', 'key', 'keyUnmasked', 'createdAt', 'expiresAt', 'webhookSubscriptionCount'),
  account: item.account ? Account.fromGql(item.account) : undefined,
  permissionSet: item.permissionSet ? PermissionScope.fromGqlPermissionSet(item.permissionSet) : undefined,
});
